import {
  ColumnMenu,
  ColumnOption
} from 'src/components/shared/DataGrid/ColumnMenu';
import { SpecificationDto } from 'src/store/specifications/specification';
import { LocalStorage } from 'src/utils/localStorage';

export const SPECIFICATION_COLUMNS_KEY = 'specification_columns';

const specificationColumns: ColumnOption<SpecificationDto>[] = [
  {
    title: 'props.number',
    field: 'no',
    disabled: true
  },
  {
    title: 'props.name',
    field: 'name',
    disabled: true
  },
  {
    title: 'props.date',
    field: 'regDate'
  },
  {
    title: 'segment.singular',
    field: 'segmentName'
  },
  {
    title: 'grade.singular',
    field: 'gradeName'
  },
  {
    title: 'customer.singular',
    field: 'customerName'
  },
  {
    title: 'packaging.singular',
    field: 'packagingName'
  },
  {
    title: 'pallet.singular',
    field: 'palletName'
  },
  {
    title: 'props.active',
    field: 'active'
  }
];

export const getSpecificationColumns = (): ColumnOption<SpecificationDto>[] =>
  LocalStorage.getItem(SPECIFICATION_COLUMNS_KEY) ?? specificationColumns;

type SpecificationsListColumnMenuProps = {
  selectedColumns: ColumnOption<SpecificationDto>[];
  onSelectedColumnsChange: (columns: ColumnOption<SpecificationDto>[]) => void;
};

export function SpecificationsListColumnMenu({
  selectedColumns,
  onSelectedColumnsChange
}: SpecificationsListColumnMenuProps) {
  const onColumnsChange = (columns: ColumnOption<SpecificationDto>[]) => {
    onSelectedColumnsChange(columns);
    LocalStorage.setItem(SPECIFICATION_COLUMNS_KEY, columns);
  };

  return (
    <ColumnMenu
      columns={specificationColumns}
      selectedColumns={selectedColumns}
      onColumnsChange={onColumnsChange}
    />
  );
}
